import "./i18n/i18n";
import React from "react";
import { VaporThemeProvider } from "@vapor/v3-components";
import { BrowserRouter as Router } from "react-router-dom";
import AppRouter from "./Router/AppRouter";
import { Provider } from "react-redux";
import { store } from "./store/store";

const App: React.FC = () => {
  return (
    <VaporThemeProvider>
      <Provider store={store}>
        <Router>
          <AppRouter />
        </Router>
      </Provider>
    </VaporThemeProvider>
  );
};

export default App;
